<template>
<div>
    <test-page-header
        :title="testBeingPassing.name"
        :is-show-navigation="false"
    />

    <h2 class="my-1">{{ trans.respondent_form.title }}</h2>

    <div class="field">
        <div class="control">
            <label class="label">{{ trans.respondent_form.name }}</label>
            <input class="input" type="text" v-model="name">
        </div>
        <p class="help is-danger" v-for="(error, index) in errors.name" :key="index">
            {{error}}
        </p>
    </div>

    <div class="field">
        <div class="control">
            <label class="label">{{ trans.respondent_form.email }}</label>
            <input class="input" type="email" v-model="email">
        </div>
        <p class="help is-danger" v-for="(error, index) in errors.email" :key="index">
            {{error}}
        </p>
    </div>

    <div class="field mt-2">
        <div class="control">
            <button class="button is-info" @click="submit" :disabled="!email || !name">
                {{ trans.respondent_form.continue }}
            </button>
        </div>
    </div>
</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "TestRespondentForm",
    data() {
        return {
            name: '',
            email: '',
            errors: {},
        };
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
            'testBeingPassing',
        ]),
    },
    methods: {
        ...mapActions('tests', [
            'storeRespondent',
            'showStoreRespondentConfirmation',
            'hideConfirmationModal',
        ]),
        submit() {
            this.storeRespondentHandler();
        },
        storeRespondentHandler(authIgnore = false) {
            this.storeRespondent({
                name: this.name,
                email: this.email,
                authIgnore: authIgnore,
            }).catch(({response}) => {
                if (response.status === 309) {
                    this.showStoreRespondentConfirmation({
                        cancelHandler: () => {
                            this.hideConfirmationModal();
                            this.storeRespondentHandler(true);
                        }
                    });
                    return;
                }

                if (response.status === 422 && response.data.errors) {
                    this.errors = response.data.errors;
                }
            });
        },
    },
}
</script>